import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from '@/lib/motion-wrapper';

const MovingBanner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const messages = [
    { text: 'Free Delivery on Orders Above ₹599', icon: '🚚' },
    { text: '100% Natural & Pure', icon: '🌿' },
    { text: '100% Secure Checkout', icon: '🔒' },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 3000); // Change message every 3 seconds

    return () => clearInterval(interval);
  }, [messages.length]);

  // Animation variants for the message
  const messageVariants = {
    enter: {
      y: -20,
      opacity: 0,
    },
    center: {
      y: 0,
      opacity: 1,
    },
    exit: {
      y: 20,
      opacity: 0,
    },
  };

  return (
    <div className="bg-brand-600 text-white py-1.5 overflow-hidden">
      <div className="container-custom">
        <div className="flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              className="flex items-center justify-center w-full"
              initial="enter"
              animate="center"
              exit="exit"
              variants={messageVariants}
              transition={{ duration: 0.5 }}
            >
              <span className="mr-2 text-sm">{messages[currentIndex].icon}</span>
              <span className="text-xs font-medium">{messages[currentIndex].text}</span>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default MovingBanner;
